<template>
  <v-card>
    <v-card-title class="headline">Ej inloggad!</v-card-title>

    <v-card-text>
      Din session är avslutad, logga in igen för att fortsätta!
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="green darken-1" text @click="confirm">
        Logga in
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'NotLoggedInModal',

  methods: {
    confirm() {
      this.$store.dispatch('user/logout')
      location.reload()
    }
  }
}
</script>
